import { PhotoDto } from './photoDto';
import { CertificateDto } from './certificateDto';

export interface CustomerDto {
    id?: string;
    code?: string;
    name?: string;
    country?: string;
    logo?: PhotoDto;
    customerType?: CustomerType;
    certificateCodes?: string[];
    certificates: Array<CertificateDto>;
    file?: File;
}

export enum CustomerType {
    B2B = 1,
    B2C = 2
}
